import { gql } from '@apollo/client';

export const UPSERT_IMPACT_INDICATOR = gql`
  mutation UpsertImpactIndicator($input: UpsertImpactIndicatorInput!) {
    upsertImpactIndicator(input: $input) {
      id
    }
  }
`;
